var meta = { showLeftMenu: false, headIndex: 2 };
export var router = [
	{
		path: '/malf',
		meta: meta,
		name: 'malf',
		component: resolve => require(["./malf.vue"], resolve)
	},
	{
		path: '/malfResult',
		meta: meta,
		name: 'malfResult',
		component: resolve => require(["./malfResult.vue"], resolve)
	}
]



// WEBPACK FOOTER //
// ./src/views/malf/router.js